import { DeheadingReportingTypeEnum, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, PlantsEnum, ProductionProcessTypeEnum, ShiftsEnum, SubPlantCodesEnum, SubPlantOperationStatusEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { WorkStations } from "../../workstations/workstations.entity";
import { ProductionInventory } from "./production-inventory.entity";
import { PeelingRateBasedEnum } from "@gtpl/shared-models/masters";

@Entity("production_log")
export class ProductionLog {
    @PrimaryGeneratedColumn("increment", { name: 'production_log_id' })
    productionLogId: number;

    @Column("varchar", {
        nullable: true,
        name: "lot_number",
        length: 255
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "sub_lot_number",
        length: 100
    })
    subLotNumber: string;


    @Column("int", {
        nullable: true,
        name: "sale_order_id"
    })
    saleOrderId: number;

    @Column("int", {
        nullable: true,
        name: "sale_order_item_id"
    })
    saleOrderItemId: number;

    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'operation'
    })
    operationType: OperationTypeEnum;


    @Column("varchar", {
        nullable: true,
        name: "job_number",
        length: 50
    })
    jobNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "dc_number",
        length: 50
    })
    dcNumber: string

    @Column("varchar", {
        nullable: true,
        name: "mrn_number",
        length: 50
    })
    mrnNumber: string


    @Column("int", {
        nullable: false,
        name: 'plant_id'
    })
    plantId: number;

    // @Column({
    //     type: 'enum',
    //     enum: SubPlantCodesEnum,
    //     nullable: true,
    //     name: 'sub_plant_id'
    // })
    // subPlantId: SubPlantCodesEnum;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'sub_plant_id'
    })
    subPlantId: number;

    @Column({
        type: 'enum',
        enum: WorkStationTypeEnum,
        nullable: true,
        default: WorkStationTypeEnum.INTERNAL,
        name: 'workstation_type'
    })
    workStationType: WorkStationTypeEnum;

    @Column({
        type: 'enum',
        enum: JobCompletedEnum,
        nullable: true,
        default: JobCompletedEnum.NO,
        name: 'job_status'
    })
    jobStatus: JobCompletedEnum;

    @Column({
        type: 'enum',
        enum: JobCompletedEnum,
        nullable: true,
        default: JobCompletedEnum.NO,
        name: 'assign_freezing'
    })
    assignFreezing: JobCompletedEnum;

    @Column("boolean", {
        nullable: false,
        name: "assign_cooking",
        default: true
    })
    assignCooking: boolean;

    @Column("int", {
        nullable: true,
        name: "workstation"
    })
    workStation: number;


    @Column("varchar", {
        nullable: true,
        name: "input_grade"
    })
    inputGrade: string;


    @Column("int", {
        nullable: true,
        name: "planned_grade"
    })
    plannedGrade: number;


    @Column("varchar", {
        nullable: true,
        name: "actual_grade"
    })
    actualGrade: string;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        default: 0,
        name: "input_quantity"
    })
    inputQuantity: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        default: 0,
        name: "planned_output_quantity"
    })
    plannedOutputQuantity: number;


    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: true,
        default: 0,
        name: "actual_output_quantity"
    })
    actualOutputQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "wastage_quantity"
    })
    wastageQuantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        default: 0,
        name: "rejected_quantity"
    })
    rejectedQuantity: number;


    @Column("varchar", {
        nullable: true,
        name: "rejection_reason",
        length: 100
    })
    rejectionReason: string;


    // @Column({
    //     type: "decimal", precision: 10, scale: 3,
    //     nullable: true,
    //     default: 0,
    //     name: "consumed_quantity"
    // })
    // consumedQuantity: number;


    @Column("int", {
        nullable: true,
        name: "ip_boxes"
    })
    inputBoxes: number;


    @Column("int", {
        nullable: true,
        name: "op_boxes"
    })
    outputBoxes: number;


    @Column("varchar", {
        nullable: true,
        name: "assigned_user",
        length: 50
    })
    assignedUser: string
    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "soaking_time"
    })
    soakingTime: string;
    @Column("varchar", {
        nullable: true,
        name: "soaking_style",
        length: 50
    })
    soakingStyle: string


    @Column("datetime", {
        nullable: true,
        name: "assigned_time",
    })
    assignedTime: Date
    @Column("datetime", {
        nullable: true,
        name: "reported_time",
    })
    reportedTime: Date


    @Column({
        type: 'enum',
        enum: ShiftsEnum,
        nullable: true,
        name: 'shift'
    })
    shift: ShiftsEnum;


    @Column({
        type: 'enum',
        enum: SubPlantOperationStatusEnum,
        nullable: true,
        default: SubPlantOperationStatusEnum.OPEN,
        name: 'sub_plant_op_status'
    })
    isReceived: SubPlantOperationStatusEnum;

    // @Column("varchar", {
    //     nullable: true,
    //     name: "reported_by",
    //     length: 50
    // })
    // reportedBy: string | null;

    @Column("varchar", {
        nullable: true,
        name: "received_date",
        length: 50
    })
    receivedDate: string | null;


    // @Column("varchar", {
    //     nullable: true,
    //     name: "received_by",
    //     length: 50
    // })
    // receivedBy: string | null;

    @Column("int", {
        nullable: true,
        name: "prod_inv_id"
    })
    prodInvId: number;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    // @Column("varchar",{
    //     nullable:false,
    //     name:"plant_lot_number"
    // })
    // plantLotNumber:string

    @Column("enum",{
        nullable:true,
        name:"reporting_type",
        enum:DeheadingReportingTypeEnum
    })
    reportingType:DeheadingReportingTypeEnum

    @Column("varchar",{
        nullable:true,
        name:"product",
        length:100
    })
    product:string

    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'prev_operation'
    })
    prevOperation: OperationTypeEnum;

    @Column('int',{
        name:'contractor_id'
    })
    contractorId : number

    @Column('decimal',{
        name:'unit_price',
        precision: 10, scale: 2,
        unsigned:true
    })
    unitPrice : number

    @Column('decimal',{
        name:'amount',
        precision: 10, scale: 2,
        unsigned:true
    })
    amount : number

    @Column('varchar',{
        name:'bill_no',
        length:30
    })
    billNo:string
    
    @Column('datetime',{
        nullable:true,
        name:'date'
    })
    date: Date

    @Column('varchar',{
        name:'bill_type',
        length:20
    })
    billType:string

    @Column('int',{
        name:'no_of_persons'
    })
    noOfPersons : number

    @Column('varchar',{
        name:'scope_of_work',
        length:50
    })
    scopeOfWork: string

    @Column('decimal',{
        name:'average_qty',
        precision: 10, scale: 3,
    })
    averageQty: number

    @Column('text',{
        name:'reason',
        nullable:true
    })
    reason : string

    @Column('enum',{
        name:'peeling_price_based_on',
        nullable:false,
        enum:PeelingRateBasedEnum
    })
    peelingPriceBasedOn : PeelingRateBasedEnum

    @Column('boolean',{
        name:'material_from',
        default:false
    })
    materialFrom : boolean

    @Column('int',{
        name:'year'
    })
    year:number

    @Column('boolean',{
        name:'is_rrp',
        default:false,
        nullable:false
    })
    isRRP : boolean

    @Column('varchar',{
        name:'rejection_from',
        nullable:true,
        length : 30
    })
    rejectionFrom : string

    @Column('enum',{
        name:'process_type',
        nullable:false,
        default:ProductionProcessTypeEnum.FRESHPRODUCITON,
        enum:ProductionProcessTypeEnum
    })
    processType : ProductionProcessTypeEnum

    @Column('boolean',{
        name:'grade_change',
        default:false
    })
    gradeChange : boolean

    @Column('varchar',{
        name:'soakingout_product',
        length:30
    })
    soakingoutProduct : string

    @Column('int',{
        name:'reporting_log_id',
        nullable:true
    })
    reportingLogId : number

    @ManyToOne(type => WorkStations, workstation => workstation.productionLog, { nullable: true })
    @JoinColumn({ name: 'workstation' })
    workstation: WorkStations;

}